import { List } from 'immutable';
import RecipeCustomCategory, { RecipeCustomCategories } from 'records/RecipeCustomCategory';
import BaseList from 'records/BaseList';

import {
  RECIPE_CUSTOM_CATEGORIES_ASYNC_ACTION_START,
  RECIPE_CUSTOM_CATEGORIES_ASYNC_ACTION_ERROR,
  RECIPE_CUSTOM_CATEGORIES_ASYNC_UPDATE_SUCCESS,
  RECIPE_CUSTOM_CATEGORIES_UPDATE_SUCCESS,
  RECIPE_CUSTOM_CATEGORIES_DRAGGABLE_UPDATE,
  RECIPE_CUSTOM_CATEGORIES_UPDATE_ORDINALS_SUCCESS,
  RECIPE_CUSTOM_CATEGORIES_RESET_STATE,
} from 'actions/recipeCustomCategories';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [RECIPE_CUSTOM_CATEGORIES_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [RECIPE_CUSTOM_CATEGORIES_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [RECIPE_CUSTOM_CATEGORIES_ASYNC_UPDATE_SUCCESS]: (state, action) => {
    const recipeCustomCategoriesData = RecipeCustomCategories(action.data);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: recipeCustomCategoriesData,
    });
  },
  [RECIPE_CUSTOM_CATEGORIES_UPDATE_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [RECIPE_CUSTOM_CATEGORIES_DRAGGABLE_UPDATE]: (state, action) => {
    let newCategoriesData = RecipeCustomCategory.updateCategoryOrdinalsFromIndex(action.data);
    newCategoriesData = RecipeCustomCategory.sortCategoriesByOrdinal(newCategoriesData);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: newCategoriesData,
    });
  },
  [RECIPE_CUSTOM_CATEGORIES_UPDATE_ORDINALS_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [RECIPE_CUSTOM_CATEGORIES_RESET_STATE]: () => {
    return initialState;
  },
}

export default function recipeCustomCategories(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
